import { useState, useEffect } from 'react';
import InputField from '../../../components/Forms/Input/InputField';
import TextAreaField from '../../Forms/Input/TextAreaField';
import SelectField from '../../Forms/Input/SelectField';
import SvgIcon from '../../SvgIcon/SvgIcon';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { ivaTypeOptions } from '../productData';
import { useDebitNote } from '../../../hooks/purchases/useDebitNote';

interface Props {
  onAdd: (product: any) => void;
}

const AddDebitServiceForm = ({ onAdd }: Props) => {
  const {
    form: { id: debitNoteId },
  } = useSelector((state: RootState) => state.basePurchase);

  const { clearServiceToEdit, handleCancelService } = useDebitNote();

  const [form, setForm] = useState({
    description: '',
    ivaType: 'exento',
    unitCost: '',
    quantity: '',
    totalCost: '',
  });

  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    const { unitCost, quantity } = form;
    if (unitCost && quantity && parseFloat(quantity) > 0) {
      const total = parseFloat(unitCost) * parseFloat(quantity);
      setForm((prev) => ({
        ...prev,
        totalCost: total.toFixed(8),
      }));
    }
  }, [form.unitCost, form.quantity]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    const errs: typeof errors = {};
    if (!form.description) errs.description = 'Servicio requerido';
    if (!form.unitCost) errs.unitCost = 'Costo requerido';
    if (!form.quantity) errs.quantity = 'Cantidad requerida';

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    const payload = {
      debitNoteId,
      type: 'SERVICE',
      serviceDescription: form.description,
      quantity: parseFloat(form.quantity),
      unitCost: parseFloat(form.unitCost),
      totalAmount: parseFloat(form.totalCost),
      taxType: 'EXEMPT',
    };

    onAdd(payload);
  };

  useEffect(() => {
    return () => {
      clearServiceToEdit(); // o clearServiceToEdit()
    };
  }, []);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* Sección izquierda */}
        <div className="space-y-4">
          <TextAreaField
            label="Descripción del Servicio"
            name="description"
            value={form.description}
            onChange={handleChange}
            error={errors.description}
          />

          <SelectField
            label="Tipo"
            name="ivaType"
            iconKey="list"
            value={form.ivaType}
            onChange={() => {}} // Solo lectura
            options={ivaTypeOptions}
            disabled
          />
        </div>

        {/* Sección derecha */}
        <div className="space-y-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <InputField
              label="Costo Unitario"
              name="unitCost"
              value={form.unitCost}
              onChange={handleChange}
              iconKey="dollar"
              type="number"
              error={errors.unitCost}
              min={0}
              required
            />
            <InputField
              label="Cantidad"
              name="quantity"
              value={form.quantity}
              onChange={handleChange}
              iconKey="product"
              type="number"
              error={errors.quantity}
              min={0}
              required
            />
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <InputField
              label="IVA Total"
              name="iva"
              value="0.00000000"
              disabled
              iconKey="dollar"
              type="number"
            />

            <InputField
              label="Costo Total"
              name="totalCost"
              iconKey="dollar"
              type="number"
              value={form.totalCost}
              onChange={() => {}}
              disabled
            />
          </div>
        </div>
      </div>

      <div className="text-gray-600 space-y-1 text-sm dark:text-white">
        <p>IVA UNITARIO: $ 0.00000000</p>
      </div>

      {/* Botones */}
      <div className="flex justify-end gap-3 pt-4">
        <button
          type="button"
          onClick={handleAdd}
          className="inline-flex items-center gap-2 rounded-md bg-primary px-5 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-opacity-90"
        >
          <SvgIcon name="save" className="h-5 w-5" />
          Guardar
        </button>
        <button
          type="button"
          onClick={handleCancelService}
          className="inline-flex items-center gap-2 rounded-md bg-slate-500 px-5 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-opacity-90"
        >
          <SvgIcon name="cancel" className="h-5 w-5" />
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default AddDebitServiceForm;
